export default {
  zh: {
    t1: "请先完成任务再领取",
    t2: "领取成功",
    t3: "该奖励已经领过了",
    t4: "已领取",
    t5: "你已经完成今日所有任务",
    cr: "活动版权归App所有"
  },
  en: {
    t1: "Please complete the task first",
    t2: "Received Successfully",
    t3: "The reward has been received",
    t4: "Received",
    t5: "You have completed all tasks today.",
    cr: "Copyrights of the Activity Belong to App"
  },
  ar: {
    t1: "请先完成任务",
    t2: "领取成功",
    t3: "已经领取过了",
    t4: "已领取",
    t5: "你已经完成今日所有任务",
    cr: "Copyrights of the Activity Belong to App"
  },
  tr: {
    t1: "请先完成任务",
    t2: "领取成功",
    t3: "已经领取过了",
    t4: "已领取",
    t5: "你已经完成今日所有任务",
    cr: "Copyrights of the Activity Belong to App"
  },
    pt:{
    "t1": "Por favor, complete a tarefa primeiro",
    "t2": "Recebido com sucesso",
    "t3": "A recompensa foi recebida",
    "t4": "Recebido",
    "t5": "Você completou todas as tarefas de hoje.",
    "cr": "Os direitos autorais da atividade pertencem ao aplicativo"
},
    id:{
    "t1": "Silakan selesaikan tugas terlebih dahulu",
    "t2": "Berhasil diterima",
    "t3": "Hadiah telah diterima",
    "t4": "Diterima",
    "t5": "Anda telah menyelesaikan semua tugas hari ini.",
    "cr": "Hak cipta aktivitas ini milik aplikasi"
},
    uz:{
    "t1": "Iltimos, avval vazifani bajaring",
    "t2": "Muvaffaqiyatli qabul qilindi",
    "t3": "Mukofot qabul qilindi",
    "t4": "Qabul qilindi",
    "t5": "Siz bugungi barcha vazifalarni bajardingiz.",
    "cr": "Faoliyatning mualliflik huquqlari ilovaga tegishli"
},
    ru:{
    "t1": "Пожалуйста, сначала выполните задание",
    "t2": "Успешно получено",
    "t3": "Награда получена",
    "t4": "Получено",
    "t5": "Вы выполнили все задания на сегодня.",
    "cr": "Авторские права на мероприятие принадлежат приложению"
},
    fa:{
    "t1": "لطفاً ابتدا وظیفه را کامل کنید",
    "t2": "با موفقیت دریافت شد",
    "t3": "پاداش دریافت شد",
    "t4": "دریافت شد",
    "t5": "شما امروز تمام وظایف را تکمیل کرده‌اید.",
    "cr": "حق نشر این فعالیت متعلق به اپلیکیشن است"
}






}


// WEBPACK FOOTER //
// src/pages/activity/dailytasks/lang.js